import { registerApp, getWindow } from '../../utils.js';
const appId = 'creditservice';
// eslint-disable-next-line no-unused-vars
let host = null;
const browserWindow = getWindow(appId);
window.emui = window.emui || { uuid: crypto.randomUUID() };

window.emui.app = {
  uuid: window.emui.uuid,
  init: async (options) => {
    host = options.host;
    return Promise.resolve();
  },
  mount: async (options) => {
    const loanObj = await host.getObject('Loan');
    const { ssn } = await loanObj.getLoanDetails();
    setTimeout(async () => {
      const score = ssn === '123456789' ? 800 : 600;
      await loanObj.setCreditScore(score);
    }, 1000);
    return Promise.resolve();
  },
  unmount: async (options) => Promise.resolve(),
};

registerApp({ browserWindow, appId, app: window.emui.app });
